import { Link, SearchParams } from '@gogame/navigation';

import { screenSchema } from './schemas';

export const homeDashboardSearchParams = new SearchParams(screenSchema);

export const homeDashboardScreenLink = new Link(
  'home-dashboard',
  homeDashboardSearchParams
);
